export const API_URL = "https://elf-api.lungo.xyz";
